import { useAppRoutes } from "./routes";

export default function AppRoutes({ isLoggedIn, permissions }) {
  return useAppRoutes(isLoggedIn, permissions);
}